import { useCallback, useState } from "react";
import { Toaster } from "react-hot-toast";
import Header from "../fragments/admin/Header";
import Sidebar from "../fragments/admin/Sidebar";
import CompanyDataAlert from "../elements/CompanyDataAlert";
import StokRequestAlert from "../elements/StokRequestAlert";
import dsToastOptions from "../ds/toastOptions";

export default function RootAdmin({ children }) {
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);

  const handleOpenSidebar = useCallback(() => {
    setIsOpenSidebar((prev) => !prev);
  }, []);

  return (
    <>
      {/* Lewati ke konten utama — wajib per checklist aksesibilitas design system */}
      <a href="#main-content" className="skip">Lewati ke konten utama</a>

      <Toaster position="top-right" toastOptions={dsToastOptions} />

      <Sidebar isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar} />
      <Header onOpenSidebar={handleOpenSidebar} />

      {/* App Shell T5 — konten maks 1440px (sidebar di luar hitungan),
          padding 22px dan jarak antar-blok 18px sesuai .appbody design system.
          pt-topbar memberi ruang untuk topbar 62px yang posisinya fixed. */}
      <main id="main-content" className="min-h-screen lg:ml-sidebar pt-topbar bg-default">
        <div className="mx-auto flex max-w-app-content flex-col gap-[18px] p-[22px]">
          {/* Company Data Alert: Peringatan kepada pengelola untuk update data company */}
          <CompanyDataAlert />

          {/* Stok Request Alert: Peringatan kepada PIC Rekomendasi untuk request stok */}
          <StokRequestAlert />

          <div>{children}</div>
        </div>
      </main>
    </>
  );
}
